import React from "react";
import AppRow from "src/commun/composants/grille/AppRow";
import ContactServiceForm from "src/pages/contactservice/ContactServiceForm";
import { useAppState } from "src/app/state/StateProvider";


const ContactService = () => {
  const [{ user, employeurContextuel }] = useAppState();

  if (user?.typePersonne !== "Externe" || !employeurContextuel?.agence) {
    return <></>
  }

  return (
    <span className={`ferge-class`}>
      <AppRow>
        <ContactServiceForm />
      </AppRow>
    </span>
  );
};

export default ContactService;